import styled, { createGlobalStyle } from 'styled-components'
import { Layout as AntdLayout } from 'antd'
import background from '../../../assets/backgrounds/11.jpg'
const { Content: AntdContent } = AntdLayout

export const GlobalStyles = createGlobalStyle``

export const Page = styled.div``

export const Layout = styled(AntdLayout)`
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  width: 100vw;
  min-height: 100svh;
`

export const Content = styled(AntdContent)`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0px 15px;
  max-width: 400px;
`

// export const Left = styled('div')`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   flex-direction: column;
//   height: 100svh;
// `

// export const Right = styled('div')`
//   background-image: url(${background});
//   background-size: cover;
//   background-position: center;
//   overflow: hidden;
//   height: 100svh;
// `

export const Logo = styled('img')`
  // margin-bottom: 100px;
`

export const Copyright = styled('div')`
  // margin-top: 100px;
`
